/* ==========================================================================
   Carrito — actualización por AJAX (`/cart/change.js`), sin recargar.
   ========================================================================== */

(function () {
  'use strict';

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* Handling fee (app Upcharge, 2-sep-2026): el recargo viaja como una línea más
     del carrito (product_type `mws_fee_generated`). Aquí se aparta: no cuenta como
     artículo, se resta del subtotal y se pinta en su propia fila. */
  var FEE_TYPE = 'mws_fee_generated';

  function isFee(item) { return item.product_type === FEE_TYPE; }

  function feeTotal(cart) {
    var t = 0;
    for (var i = 0; i < cart.items.length; i++) if (isFee(cart.items[i])) t += cart.items[i].final_line_price;
    return t;
  }

  function productCount(cart) {
    var n = 0;
    for (var i = 0; i < cart.items.length; i++) if (!isFee(cart.items[i])) n += cart.items[i].quantity;
    return n;
  }

  function findByKey(cart, key) {
    for (var i = 0; i < cart.items.length; i++) if (cart.items[i].key === key) return cart.items[i];
    return null;
  }

  /* Se identifica la línea por su `key`, no por su índice: la app del fee quita y
     vuelve a meter su línea y desplaza los índices. Si se piden más de las que hay,
     Shopify deja la línea en el stock y contesta 422 sin el carrito: se relee, y su
     aviso («Only 7 items were added…») se enseña en la línea. */
  function change(key, quantity) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.items) return cart;
        return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (fresh) {
            fresh.notice = cart.description || cart.message || '';
            return fresh;
          });
      });
  }

  // El aviso de Shopify bajo el nombre de la línea, unos segundos
  function showNotice(li, text) {
    var el = li.querySelector('[data-cart-aviso]');
    if (!el || !text) return;
    el.textContent = text;
    clearTimeout(el.timer);
    el.timer = setTimeout(function () { el.textContent = ''; }, 6000);
  }

  /* Envío gratis (26-oct-2026): la furgoneta de Gyaa conduce hasta el peaje del umbral
     con el total del carrito (lo que mira Shopify para la tarifa «Free Shipping»). Al
     cambiar cantidades va desde donde estaba, y la primera vez que se ve la tarjeta sale
     desde $0. El globo del total y lo que falta cuentan mientras conduce. */
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var shippingAnim = 0;
  var shownTotal = null;     // lo que enseña el globo ahora mismo
  var entryObserver = null;

  function escapeHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function easeInOut(k) {
    return k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
  }

  // Cuanto más lejos va, más tarda: + y − son saltos cortos, y cruzar la carretera entera
  // (en PC mide lo que el carrito) lleva algo más de un segundo. Pasado el peaje ya no avanza.
  function driveMs(box, from, to, threshold) {
    var road = box.querySelector('[data-cart-envio-ruta]').clientWidth;
    var px = Math.abs(Math.min(to, threshold * 1.1) - Math.min(from, threshold * 1.1)) / threshold * road;
    return Math.round(Math.max(450, Math.min(1200, 380 + px * 0.55)));
  }

  // «You’re <strong>$167.04</strong> away from free shipping»
  function showAway(box, away) {
    var parts = box.dataset.faltan.split('{x}');
    box.querySelector('[data-cart-envio-msg]').innerHTML =
      escapeHtml(parts[0]) + '<strong data-cart-envio-falta>' + money(away) + '</strong>' + escapeHtml(parts[1] || '');
  }

  function showFree(box) {
    box.querySelector('[data-cart-envio-msg]').innerHTML =
      '<span class="gyaa-cart__envio-ok" aria-hidden="true"></span>' + escapeHtml(box.dataset.gratis);
  }

  function drive(box, from, total, entry) {
    var threshold = parseInt(box.dataset.umbral, 10);
    var free = total >= threshold;
    var wasFree = from >= threshold;
    var msg = box.querySelector('[data-cart-envio-msg]');
    var bubble = box.querySelector('[data-cart-envio-globo]');
    var start = shownTotal === null ? from : shownTotal;
    var ms = driveMs(box, start, total, threshold);
    cancelAnimationFrame(shippingAnim);
    box.style.setProperty('--viaje', ms + 'ms');
    box.style.setProperty('--avance', String(Math.min(1, total / threshold)));
    box.classList.toggle('is-gratis', free);
    if (reducedMotion) {
      if (free) showFree(box);
      else showAway(box, threshold - total);
      bubble.textContent = money(total);
      return;
    }

    // El mensaje cuenta lo que falta mientras conduce (y lo lee el lector de pantalla al
    // acabar, con aria-busy); el de gratis sale al pasar el peaje
    var ticking = !entry && !(wasFree && free);
    var awayFrom = Math.max(0, threshold - start);
    var awayTo = Math.max(0, threshold - total);
    if (ticking) {
      msg.setAttribute('aria-busy', 'true');
      showAway(box, awayFrom);
    }
    var strong = box.querySelector('[data-cart-envio-falta]');
    box.classList.add('is-moviendo');
    var t0 = 0;
    (function step(now) {
      t0 = t0 || now;
      var k = Math.min(1, (now - t0) / ms);
      var e = easeInOut(k);
      shownTotal = Math.round(start + (total - start) * e);
      bubble.textContent = money(shownTotal);
      if (ticking && strong) strong.textContent = money(Math.round(awayFrom + (awayTo - awayFrom) * e));
      if (k < 1) {
        shippingAnim = requestAnimationFrame(step);
        return;
      }
      box.classList.remove('is-moviendo');
      if (ticking && free) showFree(box);
      msg.removeAttribute('aria-busy');
      if (free && (entry || !wasFree)) {
        box.classList.add('is-llega');
        setTimeout(function () { box.classList.remove('is-llega'); }, 900);
      }
    })(performance.now());
  }

  function paintShipping(total) {
    var box = document.querySelector('[data-cart-envio]');
    if (!box) return;
    var from = parseInt(box.dataset.total, 10);
    if (!parseInt(box.dataset.umbral, 10) || from === total) return;
    box.dataset.total = total;
    if (entryObserver) {
      entryObserver.disconnect();
      entryObserver = null;
    }
    drive(box, from, total, false);
  }

  function bootShipping() {
    var box = document.querySelector('[data-cart-envio]');
    if (!box) return;

    // Al tocar la carretera (o pasar el ratón), la furgoneta da un salto y hace luces
    var road = box.querySelector('[data-cart-envio-ruta]');
    function honk() {
      if (reducedMotion || box.classList.contains('is-pita')) return;
      box.classList.add('is-pita');
      setTimeout(function () { box.classList.remove('is-pita'); }, 450);
    }
    road.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') honk(); });
    road.addEventListener('click', honk);

    // Sale desde $0 (colocada sin transición) cuando se ve la tarjeta
    if (reducedMotion || !('IntersectionObserver' in window)) return;
    box.classList.add('is-quieto');
    box.classList.remove('is-gratis');
    box.style.setProperty('--avance', '0');
    box.querySelector('[data-cart-envio-globo]').textContent = money(0);
    shownTotal = 0;
    void box.offsetWidth;
    box.classList.remove('is-quieto');
    entryObserver = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      entryObserver.disconnect();
      entryObserver = null;
      setTimeout(function () { drive(box, 0, parseInt(box.dataset.total, 10), true); }, 200);
    }, { threshold: 0.5 });
    entryObserver.observe(box);
  }

  function repaint(cart) {
    var fee = feeTotal(cart);
    var count = productCount(cart);
    var subtotal = document.querySelector('[data-cart-subtotal]');
    var feeRow = document.querySelector('[data-cart-fee-row]');
    var feeEl = document.querySelector('[data-cart-fee]');
    var total = document.querySelector('[data-cart-total]');
    var summary = document.querySelector('[data-cart-summary]');
    var barTotal = document.querySelector('[data-cart-barra-total]');
    var countEl = document.querySelector('[data-cart-items]'); // [data-cart-count] es el globo del header
    var ship = document.querySelector('[data-cart-ship]');
    if (summary) summary.classList.toggle('has-fee', fee > 0);
    if (subtotal) subtotal.textContent = money(cart.total_price - fee);
    if (feeEl) feeEl.textContent = money(fee);
    if (feeRow) feeRow.hidden = fee === 0;
    if (total) total.textContent = money(cart.total_price);
    if (barTotal) barTotal.textContent = money(cart.total_price);
    // «2 items»: la plantilla del plural trae un 2 de ejemplo
    if (countEl && count) countEl.textContent = (count === 1 ? countEl.dataset.one : countEl.dataset.other).replace(/\d+/, count);
    // Envío gratis con el mismo umbral que la carretera
    if (ship) {
      var threshold = parseInt(ship.dataset.umbral, 10);
      var free = threshold > 0 && cart.total_price >= threshold;
      ship.classList.toggle('is-gratis', free);
      ship.textContent = free ? ship.dataset.free : ship.dataset.checkout;
    }
    paintShipping(cart.total_price);
    if (window.GYAA && window.GYAA.updateCartCount) window.GYAA.updateCartCount(count);
    // Si no quedan artículos, recargar para mostrar el estado vacío
    if (count === 0) window.location.reload();
  }

  /* La app recalcula el 3% DESPUÉS de cada cambio, con su propia llamada a
     cart/update.js. Se relee el carrito un par de veces para que la fila del fee
     y el total no se queden con el valor anterior. */
  var refreshTimers = [];
  function refreshLater() {
    refreshTimers.forEach(clearTimeout);
    refreshTimers = [1000, 2600].map(function (ms) {
      return setTimeout(function () {
        fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(repaint)
          .catch(function () { /* no-op */ });
      }, ms);
    });
  }

  function bindLine(li) {
    var key = li.dataset.cartKey;
    var input = li.querySelector('[data-cart-qty]');
    var priceEl = li.querySelector('.gyaa-cart__line-price');

    function apply(qty) {
      if (qty < 0) qty = 0;
      li.classList.add('is-busy');
      root.classList.add('is-updating'); // el resumen se atenúa hasta tener el carrito nuevo
      change(key, qty)
        .then(function (cart) {
          var item = findByKey(cart, key);
          if (!item || qty === 0) {
            window.location.reload();
            return;
          }
          if (input) input.value = item.quantity;
          if (priceEl) priceEl.textContent = money(item.final_line_price);
          showNotice(li, cart.notice);
          repaint(cart);
          refreshLater();
        })
        .finally(function () {
          li.classList.remove('is-busy');
          root.classList.remove('is-updating');
        });
    }

    var minus = li.querySelector('[data-cart-minus]');
    var plus = li.querySelector('[data-cart-plus]');
    var remove = li.querySelector('[data-cart-remove]');

    if (minus) minus.addEventListener('click', function () { apply((parseInt(input.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { apply((parseInt(input.value, 10) || 1) + 1); });
    if (remove) remove.addEventListener('click', function () { apply(0); });
    if (input) input.addEventListener('change', function () { apply(parseInt(input.value, 10) || 0); });

    /* B-14: swipe-to-delete táctil (patrón del carrito de Brothers): arrastrar
       la fila a la izquierda descubre la papelera; pasado el umbral, elimina.
       Solo pointerType touch — con ratón se usa el botón Remove. */
    var fg = li.querySelector('.gyaa-cart__fg');
    if (fg) {
      var sw = null;
      fg.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'touch') return;
        if (e.target.closest('.gyaa-cart__qty, [data-cart-remove], a, input, button')) return;
        sw = { x0: e.clientX, dx: 0, on: false, id: e.pointerId };
      });
      fg.addEventListener('pointermove', function (e) {
        if (!sw || e.pointerId !== sw.id) return;
        var dx = e.clientX - sw.x0;
        if (!sw.on) {
          if (dx < -6) {
            sw.on = true;
            fg.classList.add('dragging');
            try { fg.setPointerCapture(sw.id); } catch (_) { /* no-op */ }
          } else if (dx > 6) { sw = null; return; } else { return; }
        }
        sw.dx = Math.max(-li.offsetWidth, Math.min(0, dx));
        fg.style.transform = 'translateX(' + sw.dx + 'px)';
      });
      var endSwipe = function (e) {
        if (!sw || (e && e.pointerId !== sw.id)) return;
        var dx = sw.dx, w = li.offsetWidth;
        sw = null;
        fg.classList.remove('dragging');
        if (dx < -Math.min(120, w * 0.4)) {
          fg.style.transform = 'translateX(-' + w + 'px)';
          setTimeout(function () { apply(0); }, 160);
        } else {
          fg.style.transform = '';
        }
      };
      fg.addEventListener('pointerup', endSwipe);
      fg.addEventListener('pointercancel', endSwipe);
    }
  }

  /* Hasta 1023 px, la barra de abajo con el total y el botón de pagar sale mientras el
     botón del resumen queda por debajo de la pantalla (contando lo que tapan la propia
     barra y, en el celular, la de la tienda). En PC no se pinta. */
  function bootBar() {
    var bar = document.querySelector('[data-cart-barra]');
    var main = document.querySelector('.gyaa-cart__checkout');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var nav = document.querySelector('.gyaa-nav-movil');
    var covered = bar.offsetHeight + (nav ? nav.offsetHeight : 0);
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top > 0);
    }, { rootMargin: '0px 0px -' + covered + 'px 0px' }).observe(main);
  }

  var root;

  function boot() {
    root = document.querySelector('[data-cart-root]');
    var lines = document.querySelectorAll('[data-cart-line]');
    for (var i = 0; i < lines.length; i++) bindLine(lines[i]);
    bootShipping();
    bootBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
